import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { width: "10%" }
const _hoisted_3 = { class: "d-flex justify-center" }
const _hoisted_4 = {
  width: "10%",
  class: "text-center"
}
const _hoisted_5 = {
  key: 0,
  class: "text-center",
  width: "50%",
  style: {"font-weight":"900"}
}
const _hoisted_6 = { width: "10%" }
const _hoisted_7 = { class: "d-flex justify-center" }
const _hoisted_8 = { width: "10%" }
const _hoisted_9 = { class: "d-flex justify-center" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { width: "10%" }
const _hoisted_12 = { class: "d-flex justify-center" }
const _hoisted_13 = {
  width: "10%",
  class: "text-center"
}
const _hoisted_14 = {
  width: "50%",
  class: "text-center"
}
const _hoisted_15 = { width: "10%" }
const _hoisted_16 = { class: "d-flex justify-center" }
const _hoisted_17 = { width: "10%" }
const _hoisted_18 = { class: "d-flex justify-center" }
const _hoisted_19 = {
  colspan: "7",
  style: {"text-align":"center"}
}
const _hoisted_20 = { class: "d-flex justify-center align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_edit = _resolveComponent("v-btn-edit")!
  const _component_v_btn_create = _resolveComponent("v-btn-create")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_ScopeManager = _resolveComponent("ScopeManager")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_AuditChecks = _resolveComponent("AuditChecks")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_AuditCheckEdition = _resolveComponent("AuditCheckEdition")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: "",
    key: _ctx.id
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "default_card large mx-0 my-2 pa-2 fill-height sticky-card",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "d-flex headline pl-6 align-center",
                cols: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_back, {
                    class: "mr-4",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'AccountingReviewLayoutsTable' })), ["stop"]))
                  }),
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.accountingReviewLayoutName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.accountingReviewLayoutName) = $event)),
                    label: "Nom",
                    rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                    readonly: _ctx.readOnly || !_ctx.isAccountingFirmOwner,
                    density: "compact",
                    "hide-details": ""
                  }, null, 8, ["modelValue", "rules", "readonly"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                class: "d-flex justify-end align-center",
                cols: "6"
              }, {
                default: _withCtx(() => [
                  (_ctx.displayDuplicate)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        class: "mr-2",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.duplicateAccountingReviewLayout()))
                      }, {
                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                          _createTextVNode(" Dupliquer ")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isAccountingFirmOwner)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_ctx.id)
                          ? (_openBlock(), _createBlock(_component_v_btn_edit, {
                              key: 0,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.upsertAccountingReviewLayout())),
                              disabled: _ctx.isValidDisabled
                            }, null, 8, ["disabled"]))
                          : (_openBlock(), _createBlock(_component_v_btn_create, {
                              key: 1,
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.upsertAccountingReviewLayout())),
                              disabled: _ctx.isValidDisabled
                            }, null, 8, ["disabled"]))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "default_card_wm"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "8",
            class: "d-flex justify-center align-center"
          }, {
            default: _withCtx(() => _cache[24] || (_cache[24] = [
              _createElementVNode("h4", null, "Dossier de révision pour situation intermédiaire", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "d-flex justify-start align-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_switch, {
                "hide-details": "",
                modelValue: _ctx.forSituation,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.forSituation) = $event)),
                class: "pl-2 mt-0"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-center",
        style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto; margin-top: 1vh')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table, {
                title: "",
                headers: _ctx.headers,
                items: _ctx.layout,
                "items-per-page": -1,
                "hide-default-footer": "",
                class: "table"
              }, {
                item: _withCtx((props) => [
                  (props.item.type === 'cycleTitle')
                    ? (_openBlock(), _createElementBlock("tr", {
                        key: props.item.index
                      }, [
                        _cache[26] || (_cache[26] = _createElementVNode("td", { width: "5%" }, null, -1)),
                        _createElementVNode("td", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_v_btn_icon, {
                              icon: "$fa-angle-up",
                              size: "x-small",
                              color: "secondary",
                              elevation: "0",
                              onClick: ($event: any) => (_ctx.swapRow(props.index, props.index - 1)),
                              disabled: props.index === 0 || !_ctx.isAccountingFirmOwner
                            }, null, 8, ["onClick", "disabled"]),
                            _createVNode(_component_v_btn_icon, {
                              icon: "$fa-angle-down",
                              size: "x-small",
                              color: "secondary",
                              elevation: "0",
                              onClick: ($event: any) => (_ctx.swapRow(props.index, props.index + 1)),
                              disabled: 
                                            props.index === _ctx.layout.length - 1 ||
                                            !_ctx.isAccountingFirmOwner
                                        
                            }, null, 8, ["onClick", "disabled"])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_4, [
                          _createVNode(_component_v_chip, {
                            style: {"min-width":"50px"},
                            size: "small",
                            variant: "outlined",
                            color: "primary"
                          }, {
                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                              _createTextVNode(" Titre ")
                            ])),
                            _: 1
                          })
                        ]),
                        (props.item.cycleTitle)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_5, _toDisplayString(props.item.cycleTitle), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_v_btn_icon, {
                              icon: "$oss-edit",
                              color: "secondary",
                              elevation: "0",
                              onClick: ($event: any) => (_ctx.editTitleRow(props.index)),
                              disabled: _ctx.readOnly || !_ctx.isAccountingFirmOwner,
                              size: "x-small"
                            }, null, 8, ["onClick", "disabled"])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_v_btn_trash, {
                              onClick: ($event: any) => (_ctx.removeRow(props.index)),
                              disabled: _ctx.readOnly || !_ctx.isAccountingFirmOwner,
                              size: "x-small"
                            }, null, 8, ["onClick", "disabled"])
                          ])
                        ]),
                        _cache[27] || (_cache[27] = _createElementVNode("td", { width: "5%" }, null, -1))
                      ]))
                    : (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                        _cache[28] || (_cache[28] = _createElementVNode("td", { width: "5%" }, null, -1)),
                        _createElementVNode("td", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_v_btn_icon, {
                              icon: "$fa-angle-up",
                              size: "x-small",
                              color: "secondary",
                              elevation: "0",
                              onClick: ($event: any) => (_ctx.swapRow(props.index, props.index - 1)),
                              disabled: props.index === 0 || !_ctx.isAccountingFirmOwner
                            }, null, 8, ["onClick", "disabled"]),
                            _createVNode(_component_v_btn_icon, {
                              icon: "$fa-angle-down",
                              size: "x-small",
                              color: "secondary",
                              elevation: "0",
                              onClick: ($event: any) => (_ctx.swapRow(props.index, props.index + 1)),
                              disabled: 
                                            props.index === _ctx.layout.length - 1 ||
                                            !_ctx.isAccountingFirmOwner
                                        
                            }, null, 8, ["onClick", "disabled"])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_13, [
                          _createVNode(_component_v_chip, {
                            color: "green",
                            size: "small",
                            variant: "outlined"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(props.item.type !== "ACCOUNTING_REVIEW_MANUAL_CUSTOM"
                                            ? "Contrôle bobbee"
                                            : "Contrôle cabinet"), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(props.item.title
                                        ? props.item.title
                                        : _ctx.$t(`audit.${props.item.key}.title`)), 1),
                        _createElementVNode("td", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            (
                                            props.item.type === 'ACCOUNTING_REVIEW_MANUAL_CUSTOM' ||
                                            props.item.cycleTitle
                                        )
                              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                  key: 0,
                                  icon: "$oss-edit",
                                  elevation: "0",
                                  color: "secondary",
                                  onClick: ($event: any) => (_ctx.editAuditRow(props.item, props.index)),
                                  disabled: 
                                            (props.item.type &&
                                                props.item.type !==
                                                    'ACCOUNTING_REVIEW_MANUAL_CUSTOM') ||
                                            !_ctx.isAccountingFirmOwner
                                        ,
                                  size: "x-small"
                                }, null, 8, ["onClick", "disabled"]))
                              : _createCommentVNode("", true),
                            (props.item.type !== 'ACCOUNTING_REVIEW_MANUAL_CUSTOM')
                              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                  key: 1,
                                  icon: "$oss-eye",
                                  color: "secondary",
                                  elevation: "0",
                                  onClick: ($event: any) => (_ctx.displaySelectedAudit(props.item)),
                                  size: "x-small"
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_v_btn_trash, {
                              onClick: ($event: any) => (_ctx.removeRow(props.index)),
                              disabled: _ctx.readOnly || !_ctx.isAccountingFirmOwner,
                              size: "x-small"
                            }, null, 8, ["onClick", "disabled"])
                          ])
                        ]),
                        _cache[29] || (_cache[29] = _createElementVNode("td", { width: "5%" }, null, -1))
                      ]))
                ]),
                "body.append": _withCtx(() => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_v_btn, {
                          size: "small",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleAddAuditTitleDialog()))
                        }, {
                          default: _withCtx(() => [
                            _cache[31] || (_cache[31] = _createTextVNode(" Ajouter un titre ")),
                            _createVNode(_component_v_icon, { style: {"padding-bottom":"2.5px"} }, {
                              default: _withCtx(() => _cache[30] || (_cache[30] = [
                                _createTextVNode("$add")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          size: "small",
                          class: "ml-4",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleAddAuditDialog()))
                        }, {
                          default: _withCtx(() => [
                            _cache[33] || (_cache[33] = _createTextVNode(" Ajouter un contrôle ")),
                            _createVNode(_component_v_icon, { style: {"padding-bottom":"2.5px"} }, {
                              default: _withCtx(() => _cache[32] || (_cache[32] = [
                                _createTextVNode("$add")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["headers", "items"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"]),
      _createVNode(_component_ScopeManager, {
        modelValue: _ctx.scopeSync,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.scopeSync) = $event)),
        id: _ctx.scopeId,
        "onUpdate:id": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.scopeId) = $event)),
        name: _ctx.scopeName,
        "onUpdate:name": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.scopeName) = $event)),
        readonly: _ctx.readOnly && !_ctx.isAccountingFirmOwner
      }, null, 8, ["modelValue", "id", "name", "readonly"]),
      (_ctx.addAuditDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 0,
            modelValue: _ctx.addAuditDialog,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.addAuditDialog) = $event)),
            title: _ctx.windowTitle(),
            validTitle: _ctx.editMode ? 'Enregistrer' : _ctx.displayMode ? 'Fermer' : 'Ajouter',
            onValid: _cache[17] || (_cache[17] = ($event: any) => (
                _ctx.editMode
                    ? _ctx.validateModificatedAuditRow()
                    : _ctx.addAuditDialogStep === 'createAudit' && !_ctx.displayMode
                      ? _ctx.validateNewAudit()
                      : _ctx.displayMode
                        ? _ctx.toggleAddAuditDialog()
                        : _ctx.addAuditCheck(_ctx.newAuditToAdd)
            )),
            "valid-disabled": _ctx.isValidateDisabled(),
            onPrevious: _cache[18] || (_cache[18] = ($event: any) => {
                _ctx.previous();
                _ctx.readOnly = false;
            }),
            "previous-display": _ctx.displayPreviousButton,
            onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.previous())),
            "min-width": "1200px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window, {
                modelValue: _ctx.addAuditDialogStep,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.addAuditDialogStep) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, {
                    height: "100%",
                    value: 'existingAudits'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn_primary, {
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addAuditDialogStep = 'createAudit'))
                              }, {
                                default: _withCtx(() => _cache[34] || (_cache[34] = [
                                  _createTextVNode(" Créer un nouveau contrôle ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_AuditChecks, {
                        auditCheckTypes: _ctx.auditCheckTypes,
                        alreadySelectedAudits: _ctx.layout,
                        mode: "displayOrSelect",
                        onDisplayExistingAudit: _cache[12] || (_cache[12] = ($event: any) => (_ctx.displayExistingAudit($event))),
                        "max-height": "100%"
                      }, null, 8, ["auditCheckTypes", "alreadySelectedAudits"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: 'createAudit' }, {
                    default: _withCtx(() => [
                      (_ctx.addAuditDialogStep === 'createAudit')
                        ? (_openBlock(), _createBlock(_component_AuditCheckEdition, {
                            key: 0,
                            ref: "auditCheckEdition",
                            onNewAudit: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addAuditCheck($event))),
                            onEditAudit: _cache[14] || (_cache[14] = ($event: any) => (_ctx.modifyAudit($event))),
                            auditToEdit: _ctx.auditToEdit,
                            auditToDisplay: _ctx.auditToDisplay,
                            editMode: _ctx.editMode,
                            readOnly: _ctx.readOnly
                          }, null, 8, ["auditToEdit", "auditToDisplay", "editMode", "readOnly"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["modelValue", "title", "validTitle", "valid-disabled", "previous-display"]))
        : _createCommentVNode("", true),
      (_ctx.addAuditTitleDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 1,
            modelValue: _ctx.addAuditTitleDialog,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.addAuditTitleDialog) = $event)),
            title: "Ajout d'un cycle",
            onValid: _cache[22] || (_cache[22] = ($event: any) => (_ctx.editMode ? _ctx.validateModificatedTitleRow() : _ctx.validateNewTitle())),
            validTitle: _ctx.editMode ? 'Enregistrer' : 'Ajouter',
            "valid-disabled": !_ctx.newTitle.cycleTitle,
            "min-width": "1000px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "mt-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "mb-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "2",
                        class: "d-flex align-center"
                      }, {
                        default: _withCtx(() => _cache[35] || (_cache[35] = [
                          _createElementVNode("h3", null, "Nom :", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "9" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.newTitle.cycleTitle,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newTitle.cycleTitle) = $event)),
                            "hide-details": "",
                            outlined: "",
                            label: "Nom du cycle",
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "1" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "validTitle", "valid-disabled"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}